/* eslint-disable @typescript-eslint/no-unused-vars */
import { useAmplitude } from '@/contexts/AmplitudeProvider'
import { Variant } from '@amplitude/experiment-js-client'
import { useEffect, useState } from 'react'

type WaitingFetchVariant = null
type DisabledAmplitudeTest = undefined
type ExperimentVariant = string

export type VariantValue =
  | WaitingFetchVariant
  | DisabledAmplitudeTest
  | ExperimentVariant

type HookResponse = {
  activeVariant: VariantValue
  payload: { [key: string]: [value: string] }[] | []
}

export const useAmplitudeTestAB = (
  experimentId: string,
  isFlag = false,
  active = true
): HookResponse => {
  const context = useAmplitude()
  const [variant, setVariant] = useState<Variant | null>(null)

  useEffect(() => {
    if (!!context.experiment) {
      setVariant(context.experiment.variant(experimentId))
    }
  }, [context.experiment])

  return {
    activeVariant: variant?.key,
    payload: variant?.payload || []
  }
}

export default useAmplitudeTestAB
